import React from 'react';
import { volumes } from '../data/toolkit';
import { VolumeCover } from './VolumeCover';
import { CtaButton } from './CtaButton';
export function VolumesSection() {
  return <section className="border-y border-navy-line bg-ivory py-11 sm:py-14" aria-labelledby="volumes-title" data-id="element-118" data-mp="coitqq0gfboc">
      <div className="mx-auto w-full max-w-[42rem] px-4 sm:px-6 lg:max-w-5xl" data-id="element-119" data-mp="7p698bx22gox">
        <p className="eyebrow text-[0.66rem] font-semibold text-teal sm:text-[0.72rem]" data-id="element-120" data-mp="3g4ycmv2gsqbh">
          The complete OT Clinical Toolkit™
        </p>
        <h2 id="volumes-title" className="mt-3 font-display text-[1.75rem] leading-[1.15] tracking-tight text-navy sm:text-[2.25rem]" data-id="element-121" data-mp="3c4xjs5emcckw">
          6 professional volumes.
          <span className="mt-1 block text-navy-muted" data-id="element-122" data-mp="3l3j342rwzvmq">
            One connected clinical workflow.
          </span>
        </h2>
        <p className="mt-4 text-[0.98rem] leading-relaxed text-navy-muted lg:max-w-2xl" data-id="element-123" data-mp="2xcngrl689smv">
          Instead of collecting more disconnected information, build one
          practical reference system you can return to throughout the clinical
          process.
        </p>

        <ol className="mt-6 grid grid-cols-2 gap-2.5 sm:gap-4 lg:grid-cols-3 lg:gap-5" data-id="element-124" data-mp="2ed0ncj32sjcr">
          {volumes.map(volume => <li key={volume.number} className="flex h-full flex-col rounded-xl border border-navy-line bg-white p-4 sm:p-5" data-id="element-125" data-mp="2j7o2hrc6w1eo">
              <VolumeCover number={volume.number} data-id="element-126" data-mp="1qhxve28z5zs2" />
              <p className="mt-3 text-[0.58rem] font-bold uppercase leading-tight tracking-[0.12em] text-teal sm:text-[0.64rem]" data-id="element-127" data-mp="1vfhb76lbmkm4">
                Volume {volume.number} — {volume.stage}
              </p>
              <h3 className="mt-1.5 text-[0.88rem] font-semibold leading-snug text-navy sm:text-[0.98rem]" data-id="element-128" data-mp="24g5tidhqz74t">
                {volume.title}
              </h3>
              <p className="mt-2 text-[0.8rem] leading-relaxed text-navy-muted sm:text-[0.88rem]" data-id="element-129" data-mp="3btpp6cs0zlm5">
                {volume.benefit}
              </p>
            </li>)}
        </ol>

        <div className="mt-6 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between" data-id="element-130" data-mp="1gp9jtdqqw51d">
          <p className="text-[0.92rem] leading-relaxed text-navy-muted sm:max-w-lg" data-id="element-131" data-mp="1btu56jkwy53w">
            Together, the six volumes help you move from observation → planning
            → intervention → documentation without rebuilding your workflow
            every time.
          </p>
          <CtaButton label="Get the complete toolkit" variant="teal" className="sm:w-auto sm:shrink-0" data-id="element-132" data-mp="x3d4x3k0ll8l" />
        </div>
      </div>
    </section>;
}